import { store, getContext } from "@wordpress/interactivity";

const { state } = store("frs-blocks/testimonials", {});
